import { useMemo } from "react";
import "./name-form-container.css";

const NameFormContainer = ({
  inputValue,
  inputPlaceholder,
  propTop,
  propHeight,
  propHeight1,
}) => {
  const groupDivStyle = useMemo(() => {
    return {
      top: propTop,
      height: propHeight,
    };
  }, [propTop, propHeight]);

  const rectangleDiv1Style = useMemo(() => {
    return {
      height: propHeight1,
    };
  }, [propHeight1]);

  return (
    <div className="rectangle-parent" style={groupDivStyle}>
      <div className="rectangle-div" style={rectangleDiv1Style} />
      <div className="name">{inputValue}</div>
      <div className="type-your-name">{inputPlaceholder}</div>
    </div>
  );
};

export default NameFormContainer;
